module.exports = __webpack_public_path__ + "static/5-3-f40ab6f607efcf0a6e98f7504442a414.png";